import { useState } from 'react';

import PasswordResetWrapper from 'hb-react/publicoffice/apps/PasswordChangeApp/components/PasswordChangeWrapper';
import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import PasswordResetForm from './PasswordResetForm';
import PasswordResetSuccess from './PasswordResetSuccess';

const PasswordReset = () => {
  const [resetPasswordData, setResetPasswordData] = useState();

  const submitHandler = async (values) => {
    try {
      const { data } = await axios.post(Routes.user_password_path(), {
        user: values,
      });

      setResetPasswordData({
        email: data.email,
        contact: data.network_contact,
      });
    } catch {
      displayNotif('error', __('An error has occurred'));
    }
  };

  return (
    <PasswordResetWrapper>
      {resetPasswordData ? (
        <PasswordResetSuccess {...resetPasswordData} />
      ) : (
        <PasswordResetForm onSubmit={submitHandler} />
      )}
    </PasswordResetWrapper>
  );
};

export default PasswordReset;
